/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface DeckCompanySimple {
  readonly id: string;
  readonly name: string;
  /**
   * company logo
   */
  readonly logo: string;
}
